import { useEffect, useState, memo } from "react";
import { useLiveAPIContext } from "../../contexts/LiveAPIContext";
import { FunctionDeclarations } from "./functions";
import type { ToolCall } from "../../multimodal-live-types"; // Correct ToolCall type import
import {instruction} from "./systemInstruction";
const voiceOptions = ["Puck", "Charon", "Kore", "Fenrir", "Aoede"] as const;
function AltairComponent() {
const [voiceName, setVoiceName] = useState<string>(localStorage.getItem("voicename") || "Aoede");
const { client, setConfig } = useLiveAPIContext();
useEffect(() => {
const systemPrompt = localStorage.getItem("systemPrompt") || `You are my helpful assistant. Any time you require to perform a specific action that can be performed by the provided functions, use the appropriate function from the provided list when needed.`;
localStorage.setItem("systemPrompt", systemPrompt);
const functions = FunctionDeclarations.map((item) => item.declaration) ;
setConfig({
model: "models/gemini-2.0-flash-live-001",
generationConfig: {
responseModalities: "audio",
speechConfig: {
voiceConfig: { prebuiltVoiceConfig: { voiceName } },
},
},
systemInstruction: {
parts: [
{
text: `${instruction}. additional context: ${systemPrompt}`,
},
],
},
tools: [
{ googleSearch: {} },
{ functionDeclarations: functions},
],
});
}, [setConfig, voiceName]);
useEffect(() => {
const onToolCall = async (toolCall: ToolCall) => {
const { functionCalls } = toolCall;
for (const fc of functionCalls) {
const funcItem = FunctionDeclarations.find(
(item) => item.declaration.name === fc.name
);
if (funcItem) {
const args = fc.args as any;
try {
const result = await funcItem.function(args);
console.log(result);
client.sendToolResponse({
functionResponses: [
{
response: { output: { success: true, data: result } },
id: fc.id,
},
],
});
} catch (error) {
console.error(error);
const errorMessage =
error instanceof Error ? error.message : String(error);
client.sendToolResponse({
functionResponses: [
{
response: { output: { success: false, error: errorMessage } },
id: fc.id,
},
],
});
}
}
}
};
client.on("toolcall", onToolCall);
return () => {
client.off("toolcall", onToolCall);
};
}, [client]);
return (
<div className="mb-3">
<label htmlFor="voice-select" className="form-label">
Choose Voice:
</label>
<select
id="voice-select"
className="form-select"
value={voiceName}
onChange={(e) => {
const value = e.target.value;
setVoiceName(value);
localStorage.setItem("voicename", value);
}}
>
{voiceOptions.map((voice) => (
<option key={voice} value={voice}>
{voice}
</option>
))}
</select>
</div>
);
}

export const Altair = memo(AltairComponent);
